/** @file PadletAttachmentShape schema */
import { ImageShapeCrop, T } from '@tldraw/editor'
import { createShapePropsMigrationIds, createShapePropsMigrationSequence, TLBaseShape } from 'tldraw'

const padletAttachmentShapeProps = {
  w: T.number,
  h: T.number,
  zoom: T.number,
  resizable: T.boolean,
  postId: T.number,
  isPoll: T.boolean,
  crop: ImageShapeCrop.nullable(),
}

interface PadletAttachmentShapeProps {
  w: number
  h: number
  zoom: number
  resizable: boolean
  postId: number
  isPoll: boolean
  crop: T.TypeOf<typeof ImageShapeCrop> | null
}

type PadletAttachmentShape = TLBaseShape<'padlet-attachment-shape', PadletAttachmentShapeProps>

const versions = createShapePropsMigrationIds('padlet-attachment-shape', {
  AddUploadKeyProp: 1,
  RemoveUploadKeyProp: 2,
  AddZoomProp: 3,
  AddCropProp: 4,
})

const padletAttachmentShapeMigrations = createShapePropsMigrationSequence({
  sequence: [
    {
      id: versions.AddUploadKeyProp,
      up: (props) => {
        // No-op, uploadKey is optional so we don't need to do anything
      },
      down: (props) => {
        if (props.uploadKey != null) {
          delete props.uploadKey
        }
      },
    },
    // We migrated this to meta.uploadKey instead
    {
      id: versions.RemoveUploadKeyProp,
      up: (props) => {
        if (props.uploadKey != null) {
          delete props.uploadKey
        }
      },
      down: (props) => {
        // No-op, uploadKey is optional so we don't need to do anything
      },
    },
    {
      id: versions.AddZoomProp,
      up: (props) => {
        props.zoom = 1
      },
      down: (props) => {
        delete props.zoom
      },
    },
    {
      id: versions.AddCropProp,
      up: (props) => {
        props.crop = null
      },
      down: (props) => {
        delete props.crop
      },
    },
  ],
})

export {
  PadletAttachmentShape,
  padletAttachmentShapeMigrations,
  PadletAttachmentShapeProps,
  padletAttachmentShapeProps,
  versions,
}
